/* Piobox Ink rev A (2026-09-28): places the Ink marks on Piobox pages (see pb-ink.css).
   Progressive enhancement: without this file every page works as before. The product page
   and cart build their UI in script, so a MutationObserver picks up buttons as they appear. */
(() => {
  if (document.documentElement.classList.contains("pbi-on")) return;
  document.documentElement.classList.add("pbi-on");
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Category glyphs: BLANKD's grid and shared drawings; `p` is the one orange spot plane.
  const G = {
    all: '<rect class="p" x="13.5" y="13.5" width="7" height="7" rx="2"/><rect x="3.5" y="3.5" width="7" height="7" rx="2"/><rect x="13.5" y="3.5" width="7" height="7" rx="2"/><rect x="3.5" y="13.5" width="7" height="7" rx="2"/><rect x="13.5" y="13.5" width="7" height="7" rx="2"/>',
    apparel: '<rect class="p" x="9.25" y="10" width="5.5" height="5.5" rx="1"/><path d="M8.75 3.75 4 5.75 2.75 10.5l3.25 1v8a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-8l3.25-1L20 5.75l-4.75-2c-.5 1.6-1.75 2.6-3.25 2.6s-2.75-1-3.25-2.6Z"/>',
    headwear: '<path class="p" d="M3.75 15.5a8.25 8.25 0 0 1 8.25-8.25v8.25Z"/><path d="M3.75 15.5a8.25 8.25 0 0 1 16.5 0"/><path d="M12 7.25v8.25"/><path d="M3.75 15.5H19a2.25 2.25 0 0 1 2.25 2.25H5a1.25 1.25 0 0 1-1.25-1.25Z"/>',
    bags: '<rect class="p" x="8.75" y="12.75" width="6.5" height="4.5" rx="1"/><path d="M9 9V7a3 3 0 0 1 6 0v2"/><rect x="4.75" y="9" width="14.5" height="11.5" rx="2"/>',
    drinkware: '<rect class="p" x="7.6" y="10" width="8.8" height="5" rx=".5"/><rect x="6" y="2.75" width="12" height="3" rx="1"/><path d="M7 5.75h10l-1.1 14.1a1.5 1.5 0 0 1-1.5 1.4H9.6a1.5 1.5 0 0 1-1.5-1.4Z"/>',
    office: '<rect class="p" x="11" y="7" width="5" height="4" rx=".75"/><rect x="5" y="3" width="14" height="18" rx="2"/><path d="M8.5 3v18M16.5 13.5v7.5"/>',
    tech: '<rect class="p" x="8.5" y="12.5" width="7" height="5.5" rx="1"/><rect x="6" y="4" width="12" height="17" rx="3"/><path d="M10.5 4V2.5h3V4M9.5 8.5h1M12 8.5h.01M14.5 8.5h.01"/>',
    gifting: '<rect class="p" x="3" y="6.5" width="18" height="3.5" rx="1"/><rect x="3" y="6.5" width="18" height="3.5" rx="1"/><path d="M4.5 10v8.5A1.5 1.5 0 0 0 6 20h12a1.5 1.5 0 0 0 1.5-1.5V10M12 6.5V20M12 6.5C10.6 3.4 7 3.3 7.4 5.4 7.7 6.8 10.4 6.5 12 6.5c1.6 0 4.3.3 4.6-1.1.4-2.1-3.2-2-4.6 1.1Z"/>',
    quote: '<rect class="p" x="4.75" y="2.75" width="14.5" height="5" rx="2"/><rect x="4.75" y="2.75" width="14.5" height="18.5" rx="2"/><path d="M9.5 17V8.5h3a2.25 2.25 0 0 1 0 4.5h-3M12.5 13l2.5 4"/>'
  };
  const glyph = (id) => `<svg class="pbi-g" viewBox="0 0 24 24" aria-hidden="true" focusable="false">${G[id]}</svg>`;

  // ── nav: glyphs + squeegee underline ──
  const cats = document.querySelector(".pbx-nav__cats");
  if (cats && !cats.querySelector(".pbi-squeegee")) {
    cats.querySelectorAll("a").forEach((a) => {
      const h = (a.getAttribute("href") || "").split("?")[0].replace(/\/$/, "").split("/").pop();
      if (G[h] && !a.querySelector(".pbi-g")) a.insertAdjacentHTML("afterbegin", glyph(h));
    });
    const bar = document.createElement("span");
    bar.className = "pbi-squeegee"; bar.setAttribute("aria-hidden", "true");
    cats.appendChild(bar);
    const to = (a) => {
      if (!a) { bar.classList.remove("is-on"); return; }
      const r = cats.getBoundingClientRect(), c = a.getBoundingClientRect();
      bar.style.width = `${c.width}px`;
      bar.style.transform = `translateX(${c.left - r.left + cats.scrollLeft}px)`;
      bar.classList.add("is-on");
    };
    const current = () => cats.querySelector('a[aria-current="page"]');
    cats.querySelectorAll("a").forEach((a) => a.addEventListener("mouseenter", () => to(a)));
    cats.addEventListener("mouseleave", () => to(current()));
    const settle = () => { bar.style.transition = "none"; to(current()); void bar.offsetWidth; bar.style.transition = ""; };
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(settle); else settle();
    window.addEventListener("resize", settle);
  }
  const quoteLink = document.querySelector(".pbx-nav__quote");
  if (quoteLink) { const s = quoteLink.querySelector("svg"); if (s) s.outerHTML = glyph("quote"); }

  // ── ink pull: the next move ──
  const INK = ".pbh-hero .pbh-btn--dark, .pbh-cta .pbh-btn--pumpkin, .pbx-ctas .pbx-btn--pri, .pbx-bar .pbx-btn--pri";
  const inkify = (el) => {
    if (el.querySelector(":scope > .pbi-ink__ink")) return;
    el.classList.add("pbi-ink");
    el.insertAdjacentHTML("afterbegin", '<span class="pbi-ink__ink" aria-hidden="true"><span class="pbi-ink__solid"></span><span class="pbi-ink__edge"></span><span class="pbi-ink__blade"></span></span>');
  };

  // ── stitch: commitments ──
  const STITCH = ".pbx-nav__quote, .pbh-cta .pbh-btn--line, .pbx-ctas .pbx-btn--sec, .pbx-checkout";
  const sizeStitch = (el) => {
    const s = el.querySelector(":scope > svg.pbi-st"); if (!s) return;
    // The stitch runs just inside the edge, concentric with the pill.
    const w = el.offsetWidth, h = el.offsetHeight; if (w < 20) return;
    const inset = 3.5, rx = Math.max(0, Math.min(h / 2, parseFloat(getComputedStyle(el).borderTopLeftRadius) || 0) - inset);
    s.setAttribute("width", w); s.setAttribute("height", h); s.setAttribute("viewBox", `0 0 ${w} ${h}`);
    s.querySelectorAll("rect").forEach((r) => { r.setAttribute("x", inset); r.setAttribute("y", inset); r.setAttribute("width", w - inset * 2); r.setAttribute("height", h - inset * 2); r.setAttribute("rx", rx); });
  };
  const ro = "ResizeObserver" in window ? new ResizeObserver((es) => es.forEach((e) => sizeStitch(e.target))) : null;
  const sewIO = "IntersectionObserver" in window ? new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting) return;
    sewIO.unobserve(e.target);
    if (reduce) return;
    e.target.classList.add("is-sewing");
    setTimeout(() => e.target.classList.remove("is-sewing"), 1500);
  }), { threshold: .6 }) : null;
  const stitchify = (el) => {
    if (el.querySelector(":scope > svg.pbi-st")) return;
    const first = !el.classList.contains("pbi-stitch");
    el.classList.add("pbi-stitch");
    el.insertAdjacentHTML("beforeend", '<svg class="pbi-st" aria-hidden="true" focusable="false"><rect class="hole"/><rect class="run"/></svg>');
    sizeStitch(el);
    if (!first) return;
    if (ro) ro.observe(el);
    if (sewIO) sewIO.observe(el);
  };

  // ── halftone: photos print in on first view ──
  const HT = ".pbh-card__media img, .pbh-bento__tile img, .pbx-kit-i img";
  const htIO = !reduce && "IntersectionObserver" in window ? new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting) return;
    htIO.unobserve(e.target);
    const img = e.target;
    const go = () => {
      img.classList.remove("is-waiting"); img.classList.add("is-printing");
      img.addEventListener("animationend", () => { img.classList.remove("is-printing"); img.classList.add("is-printed"); }, { once: true });
    };
    if (img.complete) go(); else { img.addEventListener("load", go, { once: true }); img.addEventListener("error", go, { once: true }); }
  }), { rootMargin: "0px 0px -8% 0px" }) : null;
  const halftone = (img) => {
    if (!htIO || img.classList.contains("pbi-ht")) return;
    const r = img.getBoundingClientRect();
    if (r.top < innerHeight && r.bottom > 0 && img.complete) return; // already on screen at load: leave it be
    img.classList.add("pbi-ht", "is-waiting");
    htIO.observe(img);
  };

  const scan = (root) => {
    root.querySelectorAll(INK).forEach(inkify);
    root.querySelectorAll(STITCH).forEach(stitchify);
    root.querySelectorAll(HT).forEach(halftone);
  };
  scan(document);

  // The product page and cart render later; catch their buttons as they arrive.
  let queued = false;
  new MutationObserver(() => {
    if (queued) return; queued = true;
    requestAnimationFrame(() => { queued = false; scan(document); });
  }).observe(document.body, { childList: true, subtree: true });
})();
